import { provideHttpClient, withFetch } from "@angular/common/http";
import {
	APP_INITIALIZER,
	ApplicationConfig,
	DEFAULT_CURRENCY_CODE,
	ErrorHandler,
} from "@angular/core";
import { MAT_CARD_CONFIG, MatCardConfig } from "@angular/material/card";
import {
	MAT_CHECKBOX_DEFAULT_OPTIONS,
	MatCheckboxDefaultOptions,
} from "@angular/material/checkbox";
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from "@angular/material/form-field";
import { MAT_ICON_DEFAULT_OPTIONS } from "@angular/material/icon";
import {
	MAT_SNACK_BAR_DEFAULT_OPTIONS,
	MatSnackBarConfig,
} from "@angular/material/snack-bar";
import {
	MAT_TOOLTIP_DEFAULT_OPTIONS,
	MatTooltipDefaultOptions,
} from "@angular/material/tooltip";
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import {
	provideRouter,
	Router,
	TitleStrategy,
	withComponentInputBinding,
	withEnabledBlockingInitialNavigation,
} from "@angular/router";
import { Loader } from "@googlemaps/js-api-loader";
import { PB_FORM_FIELD_CONFIG, PB_ICON_CONFIG } from "@pb/theme";
import { environment } from "@ppf/environment";
import { TitleService } from "@ppf/shared/title";
import * as Sentry from "@sentry/angular";
import { provideLottieOptions } from "ngx-lottie";
import { routes } from "./app.routes";

const snackBarConfig: MatSnackBarConfig = {
	duration: 7000,
	verticalPosition: "top",
	horizontalPosition: "right",
};

const checkboxConfig: MatCheckboxDefaultOptions = {
	clickAction: "check",
	color: "primary",
};

const cardConfig: MatCardConfig = { appearance: "outlined" };

const tooltipConfig: MatTooltipDefaultOptions = {
	showDelay: 0,
	hideDelay: 0,
	touchendHideDelay: 0,
	position: "above",
};

export const appConfig: ApplicationConfig = {
	providers: [
		provideRouter(
			routes,
			withComponentInputBinding(),
			withEnabledBlockingInitialNavigation(),
		),
		provideHttpClient(withFetch()),
		provideAnimationsAsync(),
		{
			provide: DEFAULT_CURRENCY_CODE,
			useValue: "USD",
		},
		// Title
		{ provide: TitleStrategy, useClass: TitleService },
		// =============
		// Theme
		// {
		// 	provide: THEME_STORAGE_KEY_TOKEN,
		// 	useValue: "pre-proposal-flow",
		// },
		// {
		// 	provide: CLIENT_THEME_KEY_TOKEN,
		// 	useValue: "qcells",
		// },
		// {
		// 	provide: APP_INITIALIZER,
		// 	useFactory: initializeThemeFactory,
		// 	multi: true,
		// 	deps: [ThemeService, THEME_STORAGE_KEY_TOKEN],
		// },
		// =============
		// Lottie
		provideLottieOptions({
			player: () => import("lottie-web"),
		}),
		// Google maps/places
		{
			provide: Loader,
			useValue: new Loader({
				apiKey: environment.googleMapsApiKey,
				libraries: ["places"],
			}),
		},
		// Sentry
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
				showDialog: true,
			}),
		},
		{
			provide: Sentry.TraceService,
			deps: [Router],
		},
		{
			provide: APP_INITIALIZER,
			useFactory: () => () => {},
			deps: [Sentry.TraceService],
			multi: true,
		},
		// ReCAPTCHA
		// {
		// 	provide: RECAPTCHA_SITE_KEY_TOKEN,
		// 	useValue: process.env["PPF_RECAPTCHA_SITE_KEY"],
		// },
		// {
		// 	provide: APP_INITIALIZER,
		// 	useFactory: recaptchaAppInitializerFactory,
		// 	deps: [DOCUMENT, RECAPTCHA_SITE_KEY_TOKEN],
		// 	multi: true,
		// },
		// Material
		{
			provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
			useValue: PB_FORM_FIELD_CONFIG,
		},
		{
			provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
			useValue: snackBarConfig,
		},
		{
			provide: MAT_ICON_DEFAULT_OPTIONS,
			useValue: PB_ICON_CONFIG,
		},
		{
			provide: MAT_CHECKBOX_DEFAULT_OPTIONS,
			useValue: checkboxConfig,
		},
		{
			provide: MAT_CARD_CONFIG,
			useValue: cardConfig,
		},
		{
			provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
			useValue: tooltipConfig,
		},
		provideClientHydration(),
	],
};
